import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import get from "@beeldit/core/services/get";
import {Order} from "@beeldit/ecommerce/orders/models/Order";

function useDownloadShipmentLabel() {
  const errorHandler = useErrorHandler();
  return (order: Order, onSuccess: any) => {
      get("orders/shipment-label", order.id, "", {
          responseType: 'blob',
      })
      .then((response: any) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", order.shipment?.label ? order.shipment?.label : '');
        document.body.appendChild(link);
        link.click();

        if (link.parentNode) {
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
        }
        onSuccess();
      })
      .catch((error: any) => {
        errorHandler(error);
      });
  };
}

export default useDownloadShipmentLabel;
